import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloCaretLeftIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path d='M13 17L6 10L13 3' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </EloBaseIcon>
)
